import React from 'react';
import {
    CreateLink,
    linkDialogPlugin,
    linkPlugin,
    markdownShortcutPlugin,
    MDXEditor,
    toolbarPlugin,
    UndoRedo
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import { cn } from '@core/utils/cn';

const POPUP_STYLES = `
.mdxeditor-popup-container { z-index: 1400; }
.mdxeditor-popup-container [class*="_linkDialogPopoverContent_"],
.mdxeditor-popup-container [class*="_dialogContent_"],
.mdxeditor-popup-container [class*="_popupContainer_"] {
    background-color: var(--popover);
    color: var(--popover-foreground);
    border: 1px solid var(--border);
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.3);
}
`;

export interface PostEditorProps {
    value: string;
    error?: string;
    disabled?: boolean;
    onChange(value: string): void;
}

export function PostEditor({
    value,
    error,
    disabled,
    onChange
}: PostEditorProps) {
    React.useEffect(() => {
        document.body.classList.add('dark-theme');
        return () => {
            document.body.classList.remove('dark-theme');
        };
    }, []);

    return (
        <div className="flex flex-col gap-1.5">
            <style>{POPUP_STYLES}</style>
            <span className="text-sm text-muted-foreground">
                Content <span className="text-destructive">*</span>
            </span>
            <div
                className={cn(
                    'overflow-hidden rounded-md border [&_.mdxeditor-toolbar]:border-b [&_.mdxeditor]:min-h-40',
                    error && 'border-destructive'
                )}
            >
                <MDXEditor
                    className="dark-theme"
                    markdown={value}
                    onChange={onChange}
                    readOnly={disabled}
                    plugins={[
                        linkPlugin(),
                        linkDialogPlugin(),
                        markdownShortcutPlugin(),
                        toolbarPlugin({
                            toolbarContents: () => (
                                <>
                                    <CreateLink />
                                    <UndoRedo />
                                </>
                            )
                        })
                    ]}
                />
            </div>
            <p className="text-xs text-muted-foreground">
                Links only in v1 — the app renders the rest. Output is plain
                markdown.
            </p>
            {error && <p className="text-xs text-destructive">{error}</p>}
        </div>
    );
}
